/**
 * Page background presets (RGB from Roblox BrickColor list where noted).
 * Ordered by hue family, then light → dark within each family.
 * @see https://htmlcolorcodes.com/roblox-color-codes/
 */
export interface PageBackgroundColorOption {
  readonly id: string;
  readonly name: string;
  readonly brickNumber: number;
  readonly rgb: readonly [number, number, number];
  readonly cssHex: string;
}

export const ROBLOX_PAGE_BACKGROUND_PALETTE: readonly PageBackgroundColorOption[] =
  [
    // Neutrals (light)
    {
      id: 'white',
      name: 'White',
      brickNumber: 0,
      rgb: [255, 255, 255],
      cssHex: '#ffffff',
    },
    {
      id: 'paper',
      name: 'Paper',
      brickNumber: 0,
      rgb: [245, 245, 244],
      cssHex: '#f5f5f4',
    },
    {
      id: 'cool-gray',
      name: 'Cool gray',
      brickNumber: 0,
      rgb: [238, 241, 245],
      cssHex: '#eef1f5',
    },
    // Greens
    {
      id: 'tr-green',
      name: 'Tr. Green',
      brickNumber: 48,
      rgb: [132, 182, 141],
      cssHex: '#84b68d',
    },
    {
      id: 'faded-green',
      name: 'Faded green',
      brickNumber: 210,
      rgb: [112, 149, 120],
      cssHex: '#709578',
    },
    // Blues
    {
      id: 'tr-blue',
      name: 'Tr. Blue',
      brickNumber: 43,
      rgb: [123, 182, 232],
      cssHex: '#7bb6e8',
    },
    {
      id: 'storm-blue',
      name: 'Storm blue',
      brickNumber: 306,
      rgb: [51, 88, 130],
      cssHex: '#335882',
    },
    // Purples
    {
      id: 'lilac',
      name: 'Lilac',
      brickNumber: 119,
      rgb: [194, 148, 210],
      cssHex: '#c294d2',
    },
    {
      id: 'bright-violet',
      name: 'Bright violet',
      brickNumber: 24,
      rgb: [180, 128, 255],
      cssHex: '#b480ff',
    },
    {
      id: 'royal-purple',
      name: 'Royal purple',
      brickNumber: 45,
      rgb: [89, 34, 89],
      cssHex: '#592259',
    },
    // Reds & oranges
    {
      id: 'tr-red',
      name: 'Tr. Red',
      brickNumber: 41,
      rgb: [205, 84, 75],
      cssHex: '#cd544b',
    },
    {
      id: 'neon-orange',
      name: 'Neon orange',
      brickNumber: 133,
      rgb: [213, 115, 61],
      cssHex: '#d5733d',
    },
    // Neutrals (dark)
    {
      id: 'charcoal',
      name: 'Charcoal',
      brickNumber: 0,
      rgb: [34, 34, 34],
      cssHex: '#222222',
    },
    {
      id: 'slate',
      name: 'Slate',
      brickNumber: 0,
      rgb: [40, 44, 52],
      cssHex: '#282c34',
    },
    {
      id: 'midnight',
      name: 'Midnight',
      brickNumber: 0,
      rgb: [18, 24, 32],
      cssHex: '#121820',
    },
    {
      id: 'deep-forest',
      name: 'Deep forest',
      brickNumber: 0,
      rgb: [20, 36, 28],
      cssHex: '#14241c',
    },
  ] as const;
